<template>
  <div
    class="linguasnapp-nav"
    v-if="showNav"
  >
    <router-link
      class="linguasnapp-nav-item"
      v-for="navItem in navItems"
      :key="navItem.text"
      :to="{ path: navItem.src, query }"
    >
      {{ navItem.text }}
    </router-link>
    <a
      class="linguasnapp-nav-item"
      href="https://www.linguasnapp.uni-hamburg.de/ablage/software/linguasnapphamburg-online-karte-v1.pdf"
      target="_blank"
    >
      Anleitung
    </a>
  </div>
</template>

<script>
export default {
    name: 'LinguasnappNav',
    data () {
        return {
            navItems: [
                { text: 'Online-Karte', src: '/' },
                { text: 'Tabellarische Ansicht', src: '/table' },
            ],
        };
    },
    computed: {
        query () {
            return this.$route.query
        },
        showNav () {
            return [ '/', '/table' ].includes(this.$route.path);
        },
    },
};
</script>

<style scoped>
.linguasnapp-nav {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  flex-grow: 1;
}

.linguasnapp-nav-item {
  padding: 15px 60px 15px 0;
  font-size: 22px;
  font-weight: 600;
  border-bottom: 1px solid #ddd;
  color: #4e4e4e;
  text-decoration: none;
}

.linguasnapp-nav-item:hover {
  color: #027bcb;
}
</style>
